import { render, staticRenderFns } from "./gtr-feedback.vue?vue&type=template&id=a8add3f6"
import script from "./gtr-feedback.ts?vue&type=script&lang=ts&external"
export * from "./gtr-feedback.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports